import { render, staticRenderFns } from "./Operatsiya.vue?vue&type=template&id=29be893f"
import script from "./Operatsiya.vue?vue&type=script&lang=js"
export * from "./Operatsiya.vue?vue&type=script&lang=js"
import style0 from "./Operatsiya.vue?vue&type=style&index=0&id=29be893f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports